var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from './index';
// Кнопка из иконки
var ButtonIcon = /** @class */ (function (_super) {
    __extends(ButtonIcon, _super);
    function ButtonIcon() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getIconSize = function (iconSize) {
            if (iconSize === 'sm') {
                return 0.66725; //16px
            }
            return 1; //24px
        };
        return _this;
    }
    ButtonIcon.prototype.render = function () {
        var _a = this.props, iconPath = _a.iconPath, title = _a.title, className = _a.className, disabled = _a.disabled, onClick = _a.onClick, id = _a.id, to = _a.to, href = _a.href, isHoverArea = _a.isHoverArea, hoverIconColor = _a.hoverIconColor, size = _a.size, badge = _a.badge, color = _a.color;
        var classNameIconContent = 'button-icon' +
            ' ' +
            (size ? size : 'md') +
            ' ' +
            (isHoverArea ? 'hover-area' : 'hover-light') +
            ' ' +
            'hover-icon-' +
            (isHoverArea ? 'area-' : 'light-') +
            'color-' +
            (hoverIconColor ? hoverIconColor : 'primary') +
            ' ' +
            (disabled ? 'disabled' : '');
        var renderIcon = (React.createElement(Icon, { path: iconPath, color: color, size: this.getIconSize(size) }));
        var iconContent;
        if (href) {
            iconContent = (React.createElement("a", { href: href, className: classNameIconContent, id: id, title: title, onClick: onClick }, renderIcon));
        }
        else if (to) {
            iconContent = (React.createElement(Link, { to: to, className: classNameIconContent, id: id, title: title }, renderIcon));
        }
        else {
            iconContent = (React.createElement("button", { type: 'button', id: id, className: classNameIconContent, title: title, onClick: onClick, disabled: disabled }, renderIcon));
        }
        var classNameResult = 'd-flex justify-content-center align-items-center ' +
            (badge ? 'button-icon-badge ' : '') +
            (className ? className : '');
        return (React.createElement("span", { className: classNameResult },
            iconContent,
            badge));
    };
    return ButtonIcon;
}(Component));
export default ButtonIcon;
//# sourceMappingURL=ButtonIcon.js.map